import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CustomTopView from "../../Components/CustomTopView";
import LeftSideNav from "../../Components/LeftSideNav";
import TopNavBar from "../../Components/TopNavbar";
import { AppConstants } from "../../Constants/AppConstants";
import { getProductCategoryDetailsAPI } from "../../Store/Action/productCategory";
import CategoryTable from "./Component/CategoryTable";
import Colors from "../../theme/Colors";

const ProductCategory = () => {
  const searchInputRef = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const limit = AppConstants.limit;
  const rowsPerPageOptions = [25, 50, 100];
  const rowsPerPageLabel = "Raw Per Pages";
  const { userData } = useSelector((state) => state.user);

  const [pageNumber, setPageNumber] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [searchQuery, setSearchQuery] = useState(""); // Added searchQuery state

  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [productCategory, setProductCategory] = useState([]);
  const [totalCount, setTotalCount] = useState(1);

  const handleChangePage = useCallback((event, newPage) => {
    setPageNumber(newPage);
  }, []);

  const handleChangeRowsPerPage = useCallback((event) => {
    setRowsPerPage(event.target.value);
    setPageNumber(0);
  }, []);

  const handleSearchChange = useCallback((event) => {
    setSearchQuery(event.target.value);
    setPageNumber(0); // Reset to the first page when search changes
  }, []);

  useEffect(() => {
    setBreadcrumbs([
      { key: "1", href: "/userList", text: "Masters" },
      { key: "2", href: "/productCategory", text: "Product Category" },
    ]);
  }, []);

  const onAddProductCategory = useCallback(() => {
    navigate("/AddProductcategory");
  }, [navigate]);

  useEffect(() => {
    const productPurityAPI = async () => {
      try {
        const params = {
          searchQuery: searchQuery || undefined,
          page: pageNumber || undefined,
          limit: limit || undefined,
        };

        dispatch(
          getProductCategoryDetailsAPI(params, (result) => {
            setProductCategory(result?.data || []);
            setTotalCount(result?.totalCount);

            if (searchInputRef.current) {
              searchInputRef.current.focus();
            }
          })
        );
      } catch (error) {
        console.log("Failed to fetch users:", error);
      }
    };
    productPurityAPI();
  }, [dispatch, limit, pageNumber, searchQuery]);

  const recordAfterSorting = productCategory?.slice(
    pageNumber * rowsPerPage,
    (pageNumber + 1) * rowsPerPage
  );

  return (
    <div style={mainContainerStyle}>
      <LeftSideNav />

      <div style={topContainerStyle}>
        <TopNavBar
          leftSideText={`Hello ${userData?.data?.user_first_name}`}
          isDashboard={true}
        />

        <CustomTopView
          breadcrumbs={breadcrumbs}
          addButtonText={"Add Customer"}
          exportButtonText={"Export Customer"}
          rowsPerPage={rowsPerPage}
          handleRowsPerPageChange={handleChangeRowsPerPage}
          rowPerPageLabel={rowsPerPageLabel}
          onAddButtonClick={onAddProductCategory}
          searchValue={searchQuery}
          onSearchChange={handleSearchChange}
        />
        <CategoryTable
          productCategory={recordAfterSorting}
          page={pageNumber}
          rowsPerPage={rowsPerPage}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          totalItems={totalCount}
          rowsPerPageOptions={rowsPerPageOptions}
          searchValue={searchQuery}
          onSearchChange={handleSearchChange}
          rowsPerPageLabel={rowsPerPageLabel}
        />
      </div>
    </div>
  );
};

const mainContainerStyle = {
  display: "grid",
  gridTemplateColumns: "20% 80%",
  height: "100vh",
  width: "100vw",
  overflowX: "hidden",
  overflowY: "hidden",
};

const topContainerStyle = {
  backgroundColor: Colors.bgColor,
  display: "flex",
  flexDirection: "column",
  height: "100%",
};

export default ProductCategory;
